import { Map } from 'immutable';

import { getExcludedSections, shapeTemplatesForAPI } from './listingsProfiles';
import { shapeVariationsForAPI } from '../variations/shapeForAPI';
import { keepOld } from '../iterable/keepOld';

import { PROFILE } from '../../constants/profiles';
import { SHOPIFY } from '../../constants/channels';
import { PRICE } from '../../constants/attributes';
import { EMPTY } from '../../constants';

export function shapeVariationsProfileForAPI({ profile, toImmutable = false }) {
  const title = profile.get('title');
  const id = profile.get('id');
  const category = profile.get('category');
  const channel = profile.get('channel');
  const invalid = profile.get('invalid');
  const templateId = parseInt(id);
  const currentProfile = Map({ profileId: id, title });
  let payload = shapeVariationsForAPI({ category, channel, profile: currentProfile, variations: profile });

  if (toImmutable) {
    payload = payload
      .set('editMode', true)
      .set('invalid', invalid)
      .set('isActive', true)
      .set('isUniqueProfile', true)
      .set('title', title);

    if (templateId) {
      payload = payload.set('templateId', templateId);
    }
  } else {
    payload.editMode = true;
    payload.invalid = invalid;
    payload.isActive = true;
    payload.isUniqueProfile = true;
    payload.title = title;

    if (templateId) {
      payload.templateId = templateId;
    }
  }

  return payload;
}

export function shapeTagsProfileForAPI({ profile }) {
  const id = profile.get('id');
  const invalid = profile.get('invalid');
  const profileName = profile.get('title');
  const tags = profile.get('tags')
    .mergeWith(keepOld, profile.get('newTags', EMPTY.ORDERED_MAP))
    .toList()
    .toArray();

  return {
    id,
    tags,
    invalid,
    profileName,
  };
}

export function shapeSaleProfileForAPI({ profile }) {
  const id = profile.get('id');
  const name = profile.get('title');
  const channel = profile.get('channel');

  const shapedProfile = {
    id,
    name,
    start_date: profile.get('startDate').toISOString(),
    end_date: profile.get('endDate').toISOString(),
    price_value: profile.get(PRICE),
    price_type: profile.get('priceType'),
    cents_value: profile.get('cents'),
    convert_to_cap: profile.get('isConvertPriceToCap'),
    description_value: profile.get('descriptionValue'),
    description_operation: profile.get('descriptionOperation'),
    title_value: profile.get('titleValue'),
    title_operation: profile.get('titleOperation'),
    tags_operation: profile.get('tagsOperation'),
    tags: Object.values(profile.get('tags', EMPTY.ORDERED_MAP).merge(profile.get('newTags', EMPTY.ORDERED_MAP)).toJS()),
  };

  if (channel === SHOPIFY) {
    shapedProfile.convert_to_cap = profile.get('isConvertPriceToCap', false);
  }

  return shapedProfile;
}

export function shapeListingsProfileForAPI({ profile, userShops }) {
  const title = profile.get('title');
  const data = profile.get('data');
  const products = data.get('products');
  const excludedSections = getExcludedSections({
    channels: profile.get('channels'),
    products,
    sections: data.get('sections'),
  });

  const templates = shapeTemplatesForAPI({ excludedSections, products, userShops });

  return { excluded_sections: excludedSections, name: title, templates };
}

export function shapeForAPI({ profile, type, ...rest }) {
  switch (type) {
    case PROFILE.LISTINGS: {
      return shapeListingsProfileForAPI({ profile, ...rest });
    }

    case PROFILE.SALES: {
      return shapeSaleProfileForAPI({ profile });
    }

    case PROFILE.TAGS: {
      return shapeTagsProfileForAPI({ profile });
    }

    case PROFILE.VARIATIONS: {
      return shapeVariationsProfileForAPI({ profile });
    }

    default:
      return {};
  }
}
